/* tslint:disable */
/* eslint-disable */
/**
 * Respa
 * The Respa API provides categorized data on resources available for reservation within a city or metropolitan area and enables the reservation of these resources. The API provides data in the JSON format, in a RESTful fashion.
 *
 * The version of the OpenAPI document: 1.6.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PurposeName
 */
export interface PurposeName {
    /**
     * The purpose in Finnish
     * @type {string}
     * @memberof PurposeName
     */
    fi?: string;
    /**
     * The purpose in Finnish
     * @type {string}
     * @memberof PurposeName
     */
    en?: string;
}

export function PurposeNameFromJSON(json: any): PurposeName {
    return PurposeNameFromJSONTyped(json, false);
}

export function PurposeNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurposeName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fi': !exists(json, 'fi') ? undefined : json['fi'],
        'en': !exists(json, 'en') ? undefined : json['en'],
    };
}

export function PurposeNameToJSON(value?: PurposeName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fi': value.fi,
        'en': value.en,
    };
}


